export default __webpack_public_path__ + "static/media/css.4a51ca49.jpeg";